import React from 'react';

const Base64Image = ({ data }) => {
  return <img src={`data:image/jpg;base64,${data}`} alt="img" />;
};

export default Base64Image;
